import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Search } from "lucide-react";

export default function BrowseProducts() {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("");
  const [cats, setCats] = useState([]);
  const [rows, setRows] = useState([]);

  const load = async () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (category) params.set("category", category);
    const { data } = await api.get(`/products?${params.toString()}`);
    setRows(data);
  };
  useEffect(() => { api.get("/meta/categories").then(r => setCats(r.data)); load(); }, []);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [q, category]);

  const quote = (p) => {
    const prefill = { product_name: p.name, category: p.category, spec: p.spec || "" };
    nav(`/app/rfqs/new?prefill=${encodeURIComponent(JSON.stringify(prefill))}`);
  };

  return (
    <>
      <PageHeader title="Browse Products" subtitle="Search the supplier catalog. Click Request Quote to pre-fill an RFQ." />
      <div className="card" style={{ padding: 16, marginBottom: 16, display: "flex", gap: 12, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 260, display: "flex", alignItems: "center", gap: 8, background: "var(--navy-900)", padding: "0 12px", border: "1px solid var(--line)", borderRadius: 4 }}>
          <Search size={16} color="var(--ink-mute)" />
          <input className="input" data-testid="browse-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search by name, model or keyword" style={{ border: 0, background: "transparent" }} />
        </div>
        <select className="input" value={category} onChange={e => setCategory(e.target.value)} style={{ maxWidth: 280 }}>
          <option value="">All categories</option>
          {cats.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div className="card">
        {rows.length === 0 ? <div style={{ padding: 32, textAlign: "center", color: "var(--ink-mute)" }}>No products found.</div> : (
          <table className="data">
            <thead><tr><th>Product</th><th>Model</th><th>Category</th><th>Stock</th><th>Lead</th><th>Price Hint</th><th></th></tr></thead>
            <tbody>
              {rows.map(p => (
                <tr key={p.id}>
                  <td><div style={{ fontWeight: 600 }}>{p.name}</div><div style={{ fontSize: 12, color: "var(--ink-mute)" }}>{p.description?.slice(0, 80)}</div></td>
                  <td className="font-mono" style={{ color: "var(--amber-400)" }}>{p.model_number || "—"}</td>
                  <td style={{ color: "var(--ink-dim)", fontSize: 13 }}>{p.category}</td>
                  <td>{p.quantity_available}</td>
                  <td>{p.lead_time_days}d</td>
                  <td>${p.price_hint?.toFixed(2) ?? "—"}</td>
                  <td><button className="btn btn-primary" data-testid={`request-quote-${p.id}`} onClick={() => quote(p)} style={{ padding: "6px 14px", fontSize: 12 }}>Request Quote →</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
